/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveSecureContainerViewProps } from './eve-secure-container';

export default (props: IEveSecureContainerViewProps) => {
    const {
        config: { hideUnauthenticated },
        context: {
            request: {
                user: { isAuthenticated }
            }
        },
        slots: { unauthenticated, authenticated }
    } = props;
    return (
        <div>
            {isAuthenticated && authenticated?.length && authenticated.map((node, idx) => <div key={idx}>{node}</div>)}
            {!isAuthenticated || !hideUnauthenticated ? unauthenticated?.map((node, idx) => <div key={idx}>{node}</div>) : null}
        </div>
    );
};
